// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px;
  border-radius: 9px;
  text-align: center;
  text-transform: uppercase;
  background: var(--default-background);
}
.wrapper .cross-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 22px;
  height: 22px;
  padding: 0px;
  z-index: 99;
}
.wrapper .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .title {
  font-size: 36px;
  line-height: 100%;
  font-weight: 700;
  text-align: left;
  text-transform: capitalize;
  font-family: var(--ion-font-family);
  margin-top: 30px;
  margin-bottom: 12px;
}
.wrapper .subtitle {
  font-family: AppFont;
  font-size: 14px;
  line-height: 100%;
  font-weight: 500;
  text-align: left;
  vertical-align: middle;
  text-transform: initial;
  color: #646466;
  margin-bottom: 35px;
}
.wrapper .input-email {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.wrapper .input-email ion-label {
  font-family: AppFont;
  font-size: 16px;
  line-height: 85%;
  font-weight: 700;
  text-align: left;
  vertical-align: middle;
  text-transform: capitalize;
}
.wrapper .input-email ion-item {
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  --inner-padding-start: 0;
  --inner-padding-end: 0;
}
.wrapper .input-email ion-item ion-input {
  font-family: var(--ion-font-family);
  border: 1px solid #919191;
  border-radius: 6px;
  font-size: 14px;
  line-height: 90%;
  vertical-align: middle;
  --padding-start: 20px;
}
.wrapper .button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.wrapper .button-wrapper ion-button {
  font-family: var(--ion-font-family);
  margin: 10px auto;
  width: 100%;
  --border-width: 0px;
  padding: 0;
  min-height: 50px;
}
.wrapper .button-wrapper ion-button span {
  padding-top: 4px;
}
.wrapper .button-wrapper .sign-up {
  --background: transparent;
  color: var(--color-black);
}
.wrapper .button-wrapper .guest {
  --background: transparent;
  color: var(--color-black);
  --border-width: 0px;
}
.wrapper.eintracht {
  background: #282828;
  color: #fff;
  border-radius: 0;
}
.wrapper.eintracht .title {
  font-size: 34px;
  font-family: EintrachtDisplay;
  font-weight: 400;
}
.wrapper.eintracht .subtitle {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ask-to-create-account-modal/ask-to-create-account-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EAEA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;AAAD;AACC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACF;AAAE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAEH;AACC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EAEA,mBAAA;AAAF;AAEC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;AAAF;AACE;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;AACH;AACE;EACC,WAAA;EACA,gBAAA;EAIA,mBAAA;EAGA,wBAAA;EACG,sBAAA;AAJN;AAKG;EACC,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;AAHJ;AAOC;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;AALF;AAME;EACC,mCAAA;EACA,iBAAA;EACG,WAAA;EACH,mBAAA;EACA,UAAA;EACA,gBAAA;AAJH;AAKG;EACC,gBAAA;AAHJ;AAME;EACC,yBAAA;EACA,yBAAA;AAJH;AAME;EACC,yBAAA;EACA,yBAAA;EACA,mBAAA;AAJH;AAOC;EACC,mBAAA;EACA,WAAA;EACA,gBAAA;AALF;AAME;EACC,eAAA;EACA,6BAAA;EACA,gBAAA;AAJH;AAOE;EACC,WAAA;AALH","sourcesContent":[".wrapper {\n\tpadding: 20px;\n\n\tborder-radius: 9px;\n\ttext-align: center;\n\ttext-transform: uppercase;  \n\tbackground: var(--default-background);\n\t.cross-icon {\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tright: 20px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t}\n\t.title {\n\t\tfont-size: 36px;\n\t\tline-height: 100%;\n\t\tfont-weight: 700;\n\t\ttext-align: left;\n\t\ttext-transform: capitalize;\n\t\tfont-family: var(--ion-font-family);\n\t\tmargin-top: 30px;\n\t\tmargin-bottom: 12px;\n\t}\n\t.subtitle {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 100%;\n\t\tfont-weight: 500;\n\t\ttext-align: left;\n\t\tvertical-align: middle;\n\t\ttext-transform: initial;\n\t\tcolor: #646466;\n\n\t\tmargin-bottom: 35px;\n\t}\n\t.input-email {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tion-label {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 85%;\n\t\t\tfont-weight: 700;\n\t\t\ttext-align: left;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\t\t}\n\t\tion-item {\n\t\t\twidth: 100%;\n\t\t\ttext-align: left;\n\t\t\t// height: 40px;\n\t\t\t// border-bottom: 1px dashed var(--ion-color-primary);\n\t\t\t// --background: transparent;\n\t\t\tmargin-bottom: 10px;\n\t\t\t// margin-top: 0px;\n\t\t\t// --padding-start: 0px;\n\t\t\t--inner-padding-start: 0;\n    \t\t--inner-padding-end: 0;\n\t\t\tion-input {\n\t\t\t\tfont-family: var(--ion-font-family);\n\t\t\t\tborder: 1px solid #919191;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 90%;\n\t\t\t\tvertical-align: middle;\n\t\t\t\t--padding-start: 20px;\n\t\t\t}\n\t\t}\n\t}\n\t.button-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tion-button {\n\t\t\tfont-family: var(--ion-font-family);\n\t\t\tmargin: 10px auto;\n    \t\twidth: 100%;\n\t\t\t--border-width: 0px;\n\t\t\tpadding: 0;\n\t\t\tmin-height: 50px;\n\t\t\tspan {\n\t\t\t\tpadding-top: 4px;\n\t\t\t}\n\t\t}\n\t\t.sign-up {\n\t\t\t--background: transparent;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t\t.guest {\n\t\t\t--background: transparent;\n\t\t\tcolor: var(--color-black);\n\t\t\t--border-width: 0px;\n\t\t}\n\t}\n\t&.eintracht {\n\t\tbackground: #282828;\n\t\tcolor: #fff;\n\t\tborder-radius: 0;\n\t\t.title {\n\t\t\tfont-size: 34px;\n\t\t\tfont-family: EintrachtDisplay;\n\t\t\tfont-weight: 400;\n\n\t\t}\n\t\t.subtitle {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
